import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {currencyFormat} from '../util/CurrencyFormatter';
import {useRecoilValue} from 'recoil';
import {userState} from '../recoil/user/userAtom';
import {getTaxDetailsForRegion} from '@bidmii/common/lib/util/TaxUtil';
import {theme} from '../Theme';
import useScreenWidth from '../hooks/useScreenWidth';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.gray.main}`,
    borderRadius: 10,
    paddingTop: 16,
    marginBottom: 16,

    // '& .MuiTypography-subtitle1': {
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: 12,
    //   },
    // },
  },
  totalBlock: {
    marginTop: 8,
    backgroundColor: theme.palette.gray.main,
    padding: 16,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
  },
}));

const UniversalPricingTable = (props: $TSFixMe) => {
  const classes = useStyles();
  const width = useScreenWidth();
  const user = useRecoilValue(userState);
  const [taxRegion, setTaxRegion] = useState(null);
  const taxFactor = (taxRegion as $TSFixMe)?.percent;

  useEffect(() => {
    setTaxRegion(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'ITaxRegion' is not assignable to... Remove this comment to see the full error message
      getTaxDetailsForRegion(user?.province || props.province || 'ON'),
    );
  }, [user, props.province]);

  const getTax = () => {
    let amount = props.subtotal;

    if (user?.balance > 0) {
      if (user.balance <= amount) {
        amount -= user.balance;
      } else {
        amount = 0.0;
      }
    }
    /*
    if (props.discount) {
      amount -= props.discount;
    }
     */
    return amount * taxFactor;
  };

  const getTotal = () => {
    let amount = props.subtotal;

    if (user?.balance > 0) {
      if (user.balance <= amount) {
        amount -= user.balance;
      } else {
        amount = 0.0;
      }
    }
    /*
    if (props.discount) {
      amount -= props.discount;
    }
     */
    return amount * (1 + taxFactor);
  };

  const getHomeownerDiscount = () => {
    const amount = props.subtotal;

    let discount = user?.balance || 0;
    if (discount > amount) {
      discount = amount;
    }
    return discount;
  };

  return (
    <div
      className={classes.root}
      style={{minWidth: width > 600 ? 350 : '80vw'}}>
      <Box>
        <Box mx={2}>
          <Typography
            variant="subtitle1"
            fontSize={18}
            style={{marginBottom: 12}}>
            Billing Amount
          </Typography>
          {props.pricingData.map((entry: $TSFixMe) => (
            <Grid container justifyContent="space-between" key={entry.title}>
              <Typography variant="subtitle2" style={{maxWidth: '70%'}}>
                {entry.title}
              </Typography>
              <Typography
                variant="subtitle2"
                style={{
                  marginLeft: entry.negative ? -7 : 0,
                  color: entry.negative
                    ? theme.palette.green.main
                    : theme.palette.primary.main,
                }}>
                {entry.negative && '- '}
                {currencyFormat(entry.amount, true)}
              </Typography>
            </Grid>
          ))}
          <Grid container justifyContent="space-between">
            <Typography variant="subtitle2" style={{marginTop: 16}}>
              SUBTOTAL
            </Typography>
            <Typography
              variant="subtitle2"
              style={{marginTop: 16}}
              data-cy="subtotal">
              {currencyFormat(props.subtotal, true)}
            </Typography>
          </Grid>
          {user?.balance > 0 && (
            <Grid container justifyContent="space-between">
              <Typography variant="subtitle2">REWARDS</Typography>
              <Typography variant="subtitle2" style={{marginLeft: -7}}>
                -{currencyFormat(getHomeownerDiscount(), true)}
              </Typography>
            </Grid>
          )}
          {/*props.discount && (
            <Grid container justifyContent="space-between">
              <Grid item>
                <Typography variant="subtitle1" style={{width: '100%'}}>
                  {props.discountLabel || 'Discount'}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="subtitle1" style={{marginLeft: -7}}>
                  -{currencyFormat(props.discount, true)}
                </Typography>
              </Grid>
            </Grid>
          )*/}
          <Grid container justifyContent="space-between">
            <Typography variant="subtitle2">TAX</Typography>
            <Typography variant="subtitle2">
              {currencyFormat(getTax(), true)}
            </Typography>
          </Grid>
        </Box>

        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          className={classes.totalBlock}>
          <Typography variant="subtitle2" style={{fontWeight: 'bold'}}>
            {props.subscription && 'MONTHLY '}TOTAL
          </Typography>
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 'bold',
              fontSize: window.outerWidth > 600 ? 20 : 18,
            }}>
            {currencyFormat(getTotal(), true)}
          </Typography>
        </Grid>
      </Box>
    </div>
  );
};

export default UniversalPricingTable;
